module.exports = __webpack_public_path__ + "img/calendar-o.a56d295a.svg";